module.exports = __webpack_public_path__ + "img/category-favorite.f5081a01.png";